import { Role } from 'core/config/roles';
import { ITab } from 'shared/components/buttons/tab-button/tab-button-interface';

/**
 * The two things the Dashboard reports on.
 *
 * Deliveries is the pharmacy round — what was expected and what got there.
 * Delivery requests is the inbound courier and transport demand, and where it
 * ends up. They answer different questions for different teams, which is why
 * each tab carries the roles that own it: the pharmacy side has no need of the
 * request numbers, and transport has no view of the delivery rounds.
 */

export enum DashboardTab {
  DELIVERIES = 'deliveries',
  DELIVERY_REQUESTS = 'delivery-requests',
}

export interface IDashboardTab extends ITab {
  key: DashboardTab;
  roles: Role[];
}

export const dashboardTabs: IDashboardTab[] = [
  {
    label: 'Deliveries',
    key: DashboardTab.DELIVERIES,
    roles: [Role.SUPER_ADMIN, Role.PHARMACY_ADMIN, Role.PHARMACY_DISPENSER],
  },
  {
    label: 'Delivery Requests',
    key: DashboardTab.DELIVERY_REQUESTS,
    // The same roles that work the request queue. This says how much of
    // D-Hive's own work is going to other suppliers, which is not a number for
    // every portal account.
    roles: [Role.SUPER_ADMIN, Role.LOGISTICS_ADMIN, Role.TRANSPORT_ADMIN],
  },
];
